import React from "react";
import { Box, Button, Card, CardContent, Divider } from "@mui/material";
import CheckboxLabel from "components/atoms/CheckboxLabel";
import FullScreenDialog from "components/atoms/FullScreenDialog";

interface IProps {
  commonHeaderTitle: string;
  originData: any[];
  itemTextKey: string;
  isVisible: boolean;
  closeModal: Function;
  onPressButton: Function;
  listItemSelected: any;
  setListItemSelected: any;
  itemImageKey?: string;
}

const SelectMultipleOption: React.FC<IProps> = ({
  commonHeaderTitle,
  isVisible,
  closeModal,
  originData,
  itemTextKey,
  onPressButton,
  listItemSelected,
  setListItemSelected,
  itemImageKey = "",
}: IProps) => {
  const ItemCard = ({ item }: any) => {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            height: 50,
            py: 1,
          }}
        >
          <span className="IgnoreExtractRuleTarget">
            <CheckboxLabel
              onClick={() => handleSelected(item)}
              checked={isCheckSelectBox(item)}
              label={item[itemTextKey]}
            />
          </span>
          {item[itemImageKey] !== undefined && item[itemImageKey] !== "" && (
            <Box
              component="img"
              src={item[itemImageKey]}
              sx={{ height: "100%", objectFit: "contain", ml: 1 }}
            />
          )}
        </Box>
        <Divider />
      </>
    );
  };

  const isCheckSelectBox = (item: any) => {
    return listItemSelected?.some((elm: any) => elm.SK == item.SK);
  };

  const handleSelected = (item: any) => {
    const cloneSelected = [...listItemSelected];
    if (isCheckSelectBox(item)) {
      setListItemSelected(
        listItemSelected?.filter((elm: any) => elm.SK !== item.SK),
      );
    } else {
      cloneSelected.push(item);
      setListItemSelected(cloneSelected);
    }
  };

  const handleButton = () => {
    onPressButton([...listItemSelected]);
    closeModal();
  };

  return (
    <FullScreenDialog
      open={isVisible}
      onClose={() => closeModal()}
      title={commonHeaderTitle}
    >
      <Card sx={{ mb: 5 }}>
        <CardContent>
          {originData &&
            originData.map((item, index) => {
              if (!item) {
                return null;
              } else {
                return <ItemCard item={item} key={index} />;
              }
            })}
        </CardContent>
      </Card>
      <Box
        sx={{
          position: "fixed",
          flexDirection: "row",
          bottom: 20,
          left: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ bgcolor: "white", borderRadius: 1, mr: 2 }}>
          <Button variant="outlined" onClick={() => closeModal()}>
            キャンセル
          </Button>
        </Box>
        <Button color="secondary" onClick={() => handleButton()}>
          決定
        </Button>
      </Box>
    </FullScreenDialog>
  );
};

export default SelectMultipleOption;
